<template>
    <div class="pt-10" v-if="product.user && product.user.values_added.length > 0">
        <div class="flex flex-gap-1 justify-content-around flex-column md:flex-row">
            <div
                v-for="(values, index) in product.user.values_added"
                :key="index"
            >
                <div class="flex justify-content-start">
                    <div class="mr-3" style="width: 60px !important;">
                        <img src="/assets/images/helpers/checkAutodeal_1.png"  style="max-width: 25px !important;">
                    </div>
                    <div class="flex flex-column">
                        <p class="text-justify" style="font-weight: 600">
                            {{ values.title }}
                        </p>
                        <p class="text-justify">
                            {{ values.text }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    }
};
</script>
